import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from '../EcosystemData/style'

const removeEcologicalIntegrityModal = ({ closeModal, confirmRemove, item }) => {
  return (
    <>
      <RemoveItemModalText data-testid='modal-body'>
        Are you sure you want to permanently remove <b>{item?.EcoRegion?.name || ''}</b> from the list? This action cannot be
        undone.
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type='secondary' onClick={closeModal}>
          <FormattedMessage id='cancel' />
        </Button>
        <Button type='destructive' onClick={confirmRemove}>
          <FormattedMessage id='yesRemove' />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

export default removeEcologicalIntegrityModal
